import React from "react";
import { Grid, Segment } from "semantic-ui-react";
import "../auth.css";
import "../card.css";
import axios from "axios";
import Table from "react-bootstrap/Table";
import PhoneInput from "react-phone-input-2";
import { connect } from "react-redux";
import Select from "react-select";
import { SemanticToastContainer, toast } from "react-semantic-toasts";
import { reactLocalStorage } from "reactjs-localstorage";
import {
  Button,
  Checkbox,
  Divider,
  Form,
  Header,
  Icon,
  Input,
  Modal,
  Pagination,
} from "semantic-ui-react";
import i18n from "../i18n";
import Menutest from "./menu.js";
import { API_BASE_URL } from "../utils/endpoints";

// import "react-phone-input-2/dist/style.css";
import "react-semantic-toasts/styles/react-semantic-alert.css";

const filter = {
  marginTop: 150,
  marginLeft: "30%",
  height: "auto",
  textAlign: "left",
  width: 500,
};
const filtera = {
  marginTop: 150,
  marginLeft: "25%",
  height: "auto",
  textAlign: "left",
  width: 500,
};

const modDelete = {
  marginTop: 200,
  marginLeft: "30%",
  height: "auto",
  width: 700,
  textAlign: "left",
};

const modDeletea = {
  marginTop: 200,
  marginLeft: "15%",
  height: "auto",
  width: 700,
  textAlign: "left",
};

const modAssign = {
  marginTop: 200,
  marginLeft: "30%",
  height: "auto",
  width: 700,
  textAlign: "left",
};
const modAssigna = {
  marginTop: 200,
  marginLeft: "15%",
  height: "auto",
  width: 700,
  textAlign: "right",
};
const modEdit = {
  marginTop: 60,
  marginLeft: "30%",
  height: "auto",
  textAlign: "left",
};

const modEdita = {
  marginTop: 60,
  marginLeft: 300,
  height: "auto",
  textAlign: "left",
};

const modAdd = {
  marginTop: 50,
  marginLeft: "25%",
  height: "auto",
  textAlign: "left",
};

const modAdda = {
  marginTop: 50,
  marginLeft: "10%",
  height: "auto",
  textAlign: "left",
};
var senders = [];
var countryOptions = [];
var sender_option = [];
var value_option = [];
var value_options = [];
var selectedOption = [];
var array_send_sender = [];
var balance_type = [];

const customStylesstop = {
  content: {
    width: "40%",
    marginRight: "30%",
    marginLeft: "30%",
    height: "231px",
    marginTop: "6%",
    background: " #fcfcfc !important",
  },
};

class ViewForm extends React.Component {
  state = { activeIndex: 0 };
  constructor(props) {
    super(props);
    this.state = {
      persons: [],
      Expiry: [],
      isLoading: true,
      errors: null,
      id: "",
      personssearch: [],
      isArabic: false,
      ShowOperator: false,
      balanceType: "",
      balance: "",
      balanceTypePromotion: "",
      balancePromotion: "",
      superOperator: false,
      IsOpenDeleteContact: false,
      adminIdForeDelet: "",
      adminNameForeDelete: "",
      modalOpenAdd1: false,
      modalOpenAdd2: false,
      modalOpenAdd3: false,
      modalOpenEdit: false,
      modalOpenDelete: false,
      nextState: false,
      isBlockOtp: false,

      totalpage: 1,
      subtotalpage: 1,
      filterTotalpage: 1,
      subpersons: [],
      searchWord: "",
      activePage: 1,
      totalpagesearch: 1,
      searchactivepage: 1,
      invoiceTotalpage: 1,
      modalOpenInvoice: false,
      customerID: "",
      Invoices: [],
      modalOpenSenderIds: false,
      SenderIds: [],
      senderIdUserId: "",
      fromDate: new Date(),
      toDate: new Date(),
      firstname: "",
      lastname: "",
      email: "",
      account_status: false,
      expiry: "",
      mobile_number: "",
      land_line: "",
      weight: "",
      selected: [],
      account_status_value: false,
      isArabic: false,
      userName: "",
      superOperator: false,
      selectedOption: [],

      //////////////////////////////////////////// from add admin///////////////////////
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      expiry: "",
      mobile_number: "",
      land_line: "",
      weight: "",
      type: [
        { label: "Bulk SMS", value: "bulk" },
        { label: "Profiled SMS", value: "profiled" },
        { label: "LBA SMS", value: "lba" },
        { label: "Survey SMS", value: "survey" },
        { label: "International SMS", value: "international" },
      ],
      typeselect: "",
      balance: 0,
      senderidselect: "",
      options_sender: [],
      user_id: [],
      expiry_data: "",
      code: "",
      enable: true,
      enable2: true,
      expiry_data_balance: "",
      userName: "",
      showsub: false,
      isArabic: false,
      modalIsOpen: false,
      user_ids: "",
      superOperator: false,
      modalOpenBalanceDetails: false,
      Type: [],
      Balance: [],
      totalBalance: [],
      modalOpensubAdmin: false,
      smsApproval: false,
      modalOpenFilterDetails: false,
      fromDate: new Date(),
      toDate: new Date(),
      Next: false,
    };
  }

  handleOpenAdd1 = () => this.setState({ modalOpenAdd1: true });
  handleCloseAdd1 = () => this.setState({ modalOpenAdd1: false });

  handleOpenInvoice = () => this.setState({ modalOpenInvoice: true });
  handleCloseInvoice = () => this.setState({ modalOpenInvoice: false });

  handleOpenSenderIds = () => this.setState({ modalOpenSenderIds: true });
  handleCloseSenderIds = () => this.setState({ modalOpenSenderIds: false });

  openSenderIds = (userId) => {
    if (!userId) {
      return;
    }

    this.setState({
      senderIdUserId: userId,
      modalOpenSenderIds: true,
      SenderIds: [],
    });

    const token = reactLocalStorage.get("accessToken");
    const ip = API_BASE_URL;
    const s2 = "localhost:3000";
    let apiBaseUrl;

    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/senderid/getSenderIds?user_id=" +
        userId;
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/senderid/getSenderIds?user_id=" +
        userId;
    }

    const headers = { "Content-Type": "application/json", token };

    axios
      .get(apiBaseUrl, { headers })
      .then((res) => {
        if (res.data?.result?.sender_ids) {
          this.setState({ SenderIds: res.data.result.sender_ids });
        } else {
          this.setState({ SenderIds: [] });
        }
      })
      .catch(() => {
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: i18n.t("Something_wrong.label"),
          animation: "bounce",
          time: 5000,
        });
        this.setState({ SenderIds: [] });
      });
  };

  handleOpenFilterDetails = () =>
    this.setState({ modalOpenFilterDetails: true });
  handleCloseFilterDetails = () =>
    this.setState({ modalOpenFilterDetails: false });

  handleOpenAdd2 = () => this.setState({ modalOpenAdd2: true });
  handleCloseAdd2 = () => {
    this.setState({ modalOpenAdd2: false });
  };

  handleOpenAdd3 = () => {
    this.setState({ modalOpenAdd3: true });
  };
  handleCloseAdd3 = () => {
    window.location = "addsubadmin";
    this.setState({ modalOpenAdd3: false });
  };

  handleOpenEdit = () => this.setState({ modalOpenEdit: true });
  handleCloseEdit = () => this.setState({ modalOpenEdit: false });

  handleOpenDelete = () => this.setState({ modalOpenDelete: true });
  handleCloseDelete = () => this.setState({ modalOpenDelete: false });

  handleOpensubAdmin = () => this.setState({ modalOpensubAdmin: true });
  handleClosesubAdmin = () => this.setState({ modalOpensubAdmin: false });

  handleOpenBalanceDetails = () =>
    this.setState({ modalOpenBalanceDetails: true });
  handleCloseBalanceDetails = () =>
    this.setState({ modalOpenBalanceDetails: false });

  openModalDeleteAdmin(e) {
    this.setState({
      IsOpenDeleteContact: true,
      adminIdForeDelet: e.target.id,
      adminNameForeDelete: e.target.name,
    });
  }

  Editform = (event) => {
    this.setState({ id: event.target.id });
    reactLocalStorage.set("id_user_edit", event.target.id);
    reactLocalStorage.get("id_user_edit");
    this.edit2();
    this.edit();
  };

  viewBalance(balances) {
    var data = balances;
    this.setState({ modalOpenBalanceDetails: true });
    this.getData(data);
    this.getBalance(data);
  }

  getData(balances) {
    var data = balances;
    var array = [];
    var expire = [];

    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        var type = key;
        var date = data[key].expiry;
        if (type != "ErrorDescription") {
          array.push(type);
          expire.push(date);
        }
      }
    }
    var i;
    var data = "";
    for (i = 0; i < array.length; i++) {
      data = data + array[i] + "\n";
    }
    this.setState({ Type: array });
    this.setState({ Expiry: expire });
  }

  getBalance(balances) {
    var data = balances;
    var array = [];
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        if (data[key].reserved && data[key].used == undefined) {
          var balance = data[key].balance - data[key].reserved;
        } else if (data[key].used && data[key].reserved == undefined) {
          var balance = data[key].balance - data[key].used;
        } else if (
          data[key].used == undefined &&
          data[key].reserved == undefined
        ) {
          var balance = data[key].balance;
        } else {
          var balance = data[key].balance - data[key].reserved - data[key].used;
          var balanceArray = data[key].balance;
        }
        array.push(balance);
      }
    }
    var i;
    var data = "";
    for (i = 0; i < array.length; i++) {
      data = data + array[i] + "\n";
    }
    this.setState({ totalBalance: balanceArray });
    this.setState({ Balance: array });
  }

  handleChangeMenu = (selectedOption) => {
    this.setState({ selectedOption });
    senders = selectedOption;
  };

  edit() {
    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/senderid/getSenderIds?user_id=" +
        reactLocalStorage.get("id_user_edit");
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/senderid/getSenderIds?user_id=" +
        reactLocalStorage.get("id_user_edit");
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data.result.sender_ids != undefined) {
        const senderidoption = res.data.result.sender_ids;
        var length = res.data.result.sender_ids.length;
        var i;
        const newArr = [];
        var object = {};
        var value = this.state.firstname;
        this.setState({ firstname: value });
        for (i = 0; i < length; i++) {
          object = {
            label: senderidoption[i].sender_id,
            value: senderidoption[i].id,
          };
          newArr.push(object);
        }
        this.setState({ selectedOption: newArr });
        senders = newArr;
        this.setState({ firstname: this.state.firstname });
      }
    });
  }

  edit2() {
    var token = reactLocalStorage.get("accessToken");

    var id = reactLocalStorage.get("id_user_edit");

    var apiBaseUrl =
      API_BASE_URL + "/core/user/rest/user/" +
      reactLocalStorage.get("id_user_edit") +
      "/findByUserId";

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/user/" +
        reactLocalStorage.get("id_user_edit") +
        "/findByUserId";
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/user/" +
        reactLocalStorage.get("id_user_edit") +
        "/findByUserId";
    }

    var headers = { "Content-Type": "application/json", tokken: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      this.setState({
        firstName: res.data.result.firstName,
        lastName: res.data.result.lastName,
        email: res.data.result.email,
        mobile_number: res.data.result.mobile_number,
        land_line: res.data.result.land_line,
        weight: res.data.result.weight,
        expiry: res.data.result.account_expiration,
        account_status_value: res.data.result.active,
        userName: res.data.result.userName,
        smsApproval: res.data.result.smsApproval,
        isBlockOtp: res.data.result.isBlockOtp,
      });
      this.setState({ modalOpenEdit: true });
    });
    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/senderid/getSenderIds";
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/senderid/getSenderIds";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data.result.sender_ids != undefined) {
        const senderidoption = res.data.result.sender_ids;
        var length = res.data.result.sender_ids.length;
        var i;
        const newArr = [];
        for (i = 0; i < length; i++) {
          var value_options = senderidoption[i].sender_id;

          newArr.push({
            label: value_options,
            value: senderidoption[i].id,
          });
        }
        this.setState({ options_sender: res.data.result.sender_ids });

        countryOptions = newArr;
        this.setState({ land_line: this.state.land_line });
      }
    });
  }

  handleSubmitEdit = (event) => {
    if (this.state.firstName !== "" && this.state.lastName !== "") {
      event.preventDefault();
      var role_name;
      if (reactLocalStorage.get("role") === "ROLE_OPERATOR") {
        role_name = "ROLE_ADMIN";
      }
      if (reactLocalStorage.get("role") === "ROLE_ADMIN") {
        role_name = "ROLE_SUBADMIN";
      }
      var id_user = this.state.id_user;
      var token = reactLocalStorage.get("accessToken");

      array_send_sender = [];
      var i;
      for (i = 0; i < senders.length; i++) {
        array_send_sender.push(senders[i].value);
      }

    const user = {
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      email: this.state.email,
      role_name: role_name,
      mobile_number: this.state.mobile_number,
      land_line: this.state.land_line,
      account_expiration: this.state.expiry,
      userName: this.state.userName,
      active: this.state.account_status_value,
      weight: this.state.weight,
      sender_ids: JSON.stringify(array_send_sender),
      smsApproval:this.state.smsApproval,
      isBlockOtp:this.state.isBlockOtp,
    };
    var data = user;
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/user/" +
        reactLocalStorage.get("id_user_edit") +
        "/updateUser";
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/user/" +
        reactLocalStorage.get("id_user_edit") +
        "/updateUser";
    }

      var headers = {
        "Content-Type": "application/json",
        tokken: token,
      };
      axios
        .post(apiBaseUrl, data, { headers: headers })
        .then(function(response) {
          if (response.status === 200) {
            if (response.data.status === "success") {
              window.location = "addsubadmin";
            }
            // window.location="addsubadmin";
          } else if (response.status === 204) {
            console.log("Something wrong");
          } else {
            console.log("Something wrong");
          }
        });
    } else {
      toast({
        type: "error",
        title: i18n.t("error.label"),
        description: i18n.t("fir_las.label"),
        animation: "bounce",
        time: 5000,
      });
    }
  };

  enableEdit = (event) => {
    this.setState({ account_status_value: !this.state.account_status_value });
  };

  Deleteform = (event) => {
    event.preventDefault();
    var token = reactLocalStorage.get("accessToken");

    this.setState({ id: this.state.adminIdForeDelet });
    var id_user = this.state.adminIdForeDelet;

    var apiBaseUrl;
    var ip = API_BASE_URL;
   
    var s2 = "localhost:3000";
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/user/deleteUser/" +
        id_user;
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/user/deleteUser/"+id_user
    }
    var headers = {
      "Content-Type": "application/json",
      tokken: token,
    };
    axios.post(apiBaseUrl, {}, { headers: headers }).then(function(response) {
      if (response.status === 200) {
        window.location = "addsubadmin";
      } else if (response.status === 204) {
        console.log("Something wrong");
      } else {
        console.log("Something wrong");
      }
    });
  };

  getUsers() {
    var token = reactLocalStorage.get("accessToken");

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var page_num = this.state.activePage - 1;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/user/" +
        page_num +
        "/null" +
        "/findAllUsersWithBalance";
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/user/" +
        page_num +
        "/null" +
        "/findAllUsersWithBalance";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      const persons = res.data.result.endUsers;
      var totalPages = Math.ceil(res.data.result.count / 20);
      this.setState({ totalpage: totalPages });
      this.setState({ persons });
    });
  }

  handleClick = (e, titleProps) => {
    var id = titleProps.index;
    // this.viewtype(id);
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({ activeIndex: newIndex });
  };

  searchchange = (event) => {
    //window.scrollTo(0, 0);
    if (event.target.value.length >= 2) {
      document.querySelector(".pagination").style = "display:none";
      document.querySelector(".searchpagination").style = "display:block";
      var token = reactLocalStorage.get("accessToken");

      reactLocalStorage.get("user_id_login");
      var object = {
        page: 0,
        searchQuery: event.target.value,
      };
      var ip = API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/user/searchUsersWithBalance";
      } else {
        apiBaseUrl =
          API_BASE_URL +
          "/core/user/rest/user/searchUsersWithBalance";
      }

      var headers = { "Content-Type": "application/json", token: token };
      axios.post(apiBaseUrl, object, { headers: headers }).then((res) => {
        if (res.data.result.endUsers != undefined) {
          const persons = res.data.result.endUsers;
          var total = Math.ceil(res.data.result.count / 20);

          this.setState({ persons, totalpagesearch: total });
        }
      });
    } else if (event.target.value == "") {
      this.getUsers();
    }
  };
  componentDidMount() {
    var lang = i18n.language;
    if (lang === "ar") {
      this.setState({ isArabic: true });
      document.querySelector(".green_color").style =
        "text-align:right;width: 20%;white-space: pre;";

      document.querySelector(".fixed_form").style =
        "margin-right: 0% !important;";
    }

    this.getUsers();

    if (reactLocalStorage.get("role") === "ROLE_OPERATOR") {
      this.setState({ ShowOperator: true });
    }
    if (reactLocalStorage.get("role") === "ROLE_OPERATOR_INT") {
      this.setState({ superOperator: true });
    }
  }

  handlePaginationChange = (e, { activePage }) => {
    this.setState({ activePage });
    var token = reactLocalStorage.get("accessToken");
    //window.scrollTo(0, 0);
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var page_num = activePage - 1;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/user/" +
        page_num +
        "/null" +
        "/findAllUsersWithBalance";
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/user/" +
        page_num +
        "/null" +
        "/findAllUsersWithBalance";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      const persons = res.data.result.endUsers;
      var totalPages = Math.ceil(res.data.result.count / 20);
      this.setState({ totalpage: totalPages });
      this.setState({ persons });
    });
  };

  handlePaginationChangeSearch = (e, { activePage }) => {
    this.setState({ activePage });

    //window.scrollTo(0, 0);
    var token = reactLocalStorage.get("accessToken");

    reactLocalStorage.get("user_id_login");

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var page = activePage - 1;
    var object = {
      page: page,
      searchQuery: this.state.searchWord,
    };
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/user/searchUsersWithBalance";
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/user/searchUsersWithBalance";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.post(apiBaseUrl, object, { headers: headers }).then((res) => {
      if (res.data.result.endUsers != undefined) {
        const persons = res.data.result.endUsers;
        var total = Math.ceil(res.data.result.count / 20);

        this.setState({ persons, totalpagesearch: total });
      }
    });
  };

  /////////////////////////////// from sub admin ////////////////////////////

  goToAddFunction() {
    this.setState({ modalOpenAdd1: true });

    if (reactLocalStorage.get("role") === "ROLE_OPERATOR_INT") {
      this.setState({ superOperator: true });
    }

    var x = this;
    var token = reactLocalStorage.get("accessToken");

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/balance/getBalance/" +
        reactLocalStorage.get("user_id_login");
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/balance/getBalance/" +
        reactLocalStorage.get("user_id_login");
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data.result.ErrorDescription === "user is not authenticated") {
        window.location = "/app/";
      } else {
        const data = res.data.result.balances;
        var array = [];
        if (data != undefined) {
          Object.keys(data).map(function(key) {
            array.push({
              label: key.replace(/_/g, " "),
              value: key,
            });
            balance_type = array;
          });
        }
      }
      this.setState({ code: "" });
    });

    ///////// to get sender ids from will mount function in add form page///////////////////
    if (reactLocalStorage.get("role") === "ROLE_ADMIN") {
      this.setState({ showsub: true });
    }
    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/senderid/getSenderIds";
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/senderid/getSenderIds";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data.result.sender_ids != undefined) {
        const senderidoption = res.data.result.sender_ids;
        var length = res.data.result.sender_ids.length;
        var i;
        const newArr = this.state.options_sender;
        for (i = 0; i < length; i++) {
          var value_option = senderidoption[i].sender_id;

          newArr.push({
            label: value_option,
            value: senderidoption[i].id,
          });
        }
        this.setState({ options_sender: res.data.result.sender_ids });

        countryOptions = newArr;
      }
    });
  }

  enable = (event) => {
    var mobile = event.target.id;
    if (this.state.enable === false) {
      this.setState({ enable: true });
    } else {
      this.setState({ enable: false });
    }
  };

  enable2 = (event) => {
    var mobile = event.target.id;
    if (this.state.enable2 === false) {
      this.setState({ enable2: true });
    } else {
      this.setState({ enable2: false });
    }
  };

  unBlock = (event) => {
    if (this.state.isBlockOtp === false) {
      this.setState({ isBlockOtp: true });
      //  document.getElementById("data_checkBlocked").checked = true;
    } else if (this.state.isBlockOtp === true) {
      this.setState({ isBlockOtp: false });
      // document.getElementById("data_checkBlocked").checked = false;
    }
  };

  onChangesenderid = (event) => {
    var i;
    const newArray = this.state.user_id;
    for (i = 0; i < event.length; i++) {
      if (newArray.includes(event[i].value) === false) {
        newArray.push(event[i].value);
      }
    }

    senders = newArray;
  };

  handleSubmitAdd = (event) => {
    event.preventDefault();

    //assign sender id

    const data2 = {
      user_id: this.state.user_ids,
      expiry: this.state.expiry_data_balance,
      billing_code: this.state.code,
      enable: true,
      balance_type: this.state.typeselect,
      balance_count: JSON.parse(this.state.balance),
    };
    var ip = API_BASE_URL;
    var token = reactLocalStorage.get("accessToken");
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/balance/addBalance";
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/balance/addBalance";
    }
    var headers = {
      "Content-Type": "application/json",
      token: token,
    };
    axios
      .post(apiBaseUrl, data2, { headers: headers })
      .then(function(response) {
        if (response.status === 200) {
          if (response.data.status == "no sufficient balance") {
            toast({
              type: "warning",
              title: i18n.t("warning.label"),
              description: "user created but" + " " + response.data.status,
              animation: "bounce",
              time: 3000,
            });
          }
          if (response.data.status == "wallet not found") {
            toast({
              type: "warning",
              title: i18n.t("warning.label"),
              description: "user created but" + " " + response.data.status,
              animation: "bounce",
              time: 3000,
            });
          } else if (response.data.status == "failed") {
            toast({
              type: "warning",
              title: i18n.t("warning.label"),
              description: response.data.result.ErrorDescription,
              animation: "bounce",
              time: 3000,
            });
          }
          if (response.data.status == "success") {
            setTimeout(function() {
              window.location = "addsubadmin";
            }, 3000);
          }
        } else if (response.status === 204) {
          console.log("Something wrong");
          toast({
            type: "error",
            title: i18n.t("error.label"),
            description: i18n.t("Something_wrong.label"),
            animation: "bounce",
            time: 5000,
          });
        } else {
          console.log("Something wrong");
          toast({
            type: "error",
            title: i18n.t("error.label"),
            description: i18n.t("Something_wrong.label"),
            animation: "bounce",
            time: 5000,
          });
        }
      })
      .catch(function(error) {
        console.log(error);
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: i18n.t("Something_wrong.label"),
          animation: "bounce",
          time: 5000,
        });
      });
  };

  enableAdd() {
    this.setState({ account_status: !this.state.account_status });
  }

  addAge = (event) => {
    var id = event.target.id;
    var value = event.target.value;

    if (document.getElementById(id).checked === true) {
      this.state.Age.push(value);
    } else if (document.getElementById(id).checked === false) {
      this.state.Age = this.state.Age.filter((item) => item !== value);
    }
    console.log(this.state.Age);
  };

  enableApprove = () => {
    this.setState({ smsApproval: !this.state.smsApproval });
  };

  onChangetype = (values) => {
    this.setState({ typeselect: values.value });
  };

  handleChangebalance = (event) => {
    this.setState({ balance: event.target.value });
  };

  opentwo = (event) => {
    event.preventDefault();
    var role_name;
    if (
      reactLocalStorage.get("role") === "ROLE_OPERATOR" ||
      reactLocalStorage.get("role") === "ROLE_OPERATOR_INT"
    ) {
      role_name = "ROLE_ADMIN";
    }
    if (reactLocalStorage.get("role") === "ROLE_ADMIN") {
      role_name = "ROLE_SUBADMIN";
    }

    if (this.state.firstName !== "" && this.state.lastName !== "") {
      this.setState({ nextState: true, Next: true });
      var x = this;
      var token = reactLocalStorage.get("accessToken");
      var mobile = this.state.mobile_number.replace("+", "");
      var user;
      if (this.state.showsub == true) {
        user = {
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          email: this.state.email,
          password: this.state.password,
          role_name: role_name,
          mobile_number: mobile,
          land_line: this.state.land_line,
          active: this.state.account_status,
          sender_ids: JSON.stringify(senders),
          userName: this.state.userName,
          smsApproval: this.state.smsApproval,
        };
      } else {
        user = {
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          email: this.state.email,
          password: this.state.password,
          role_name: role_name,
          mobile_number: mobile,
          land_line: this.state.land_line,
          expiry: this.state.expiry,
          active: this.state.account_status,
          weight: this.state.weight,
          sender_ids: JSON.stringify(senders),
          userName: this.state.userName,
        };
      }

    var data = user;
    var token=reactLocalStorage.get('accessToken');
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/auth/" +
        reactLocalStorage.get("user_id_login") +
        "/signup";
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/auth/" +
        reactLocalStorage.get("user_id_login") +
        "/signup";
    }
    var headers = {
      "Content-Type": "application/json",
      'token':token
    };
    axios
      .post(apiBaseUrl, data, { headers: headers })
      .then(response=> {
        if (response.status === 200){
        if (response.data.status === "success") {
          x.setState({ user_ids: response.data.result.id });
          toast({
            type: "success",
            title: i18n.t("success.label"),
            description: response.data.status,
            animation: "bounce",
            time: 3000,
          });
         
        window.location="addsubadmin"
        } else if (response.data.status === "failed") {

          x.setState({nextState:false,
            Next:false
          })
          toast({
            type: "warning",
            title: i18n.t("warning.label"),
            description: response.data.result.errorReposne,
            animation: "bounce",
            time: 3000,
          });
          
        } 
      }
        else  {
          x.setState({nextState:false})
          toast({
            type: "error",
            title: i18n.t("error.label"),
            description: i18n.t("Something_wrong.label"),
            animation: "bounce",
            time: 3000,
          });
        }
          
      })
      .catch(function(error) {
        x.setState({nextState:false})
        console.log(error);
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: i18n.t("Something_wrong.label"),
          animation: "bounce",
          time: 5000,
        });
      });
    // document.querySelector('.step_one').style = 'display:none';
    // document.querySelector('.steps_two').style = 'display:block';
   }else{
    toast({
      type: "error",
      title: i18n.t("error.label"),
      description:  i18n.t("fir_las.label"),
      animation: "bounce",
      time: 5000,
    });
   }
   

  };
  confirmRequest = () => {
    this.setState({ modalIsOpen: false });

    this.setState({ modalOpenAdd2: false });
    this.setState({ modalOpenAdd3: true });
  };

  handleOnChange = (value) => {
    this.setState({ mobile_number: value });
  };

  viewSubadmins = (event) => {
    this.setState({ modalOpensubAdmin: true });
    var id = event.target.id;
    var token = reactLocalStorage.get("accessToken");

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var page_num = this.state.activePage - 1;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/user/" +
        page_num +
        `/${id}` +
        "/findAllUsersWithBalance";
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/user/" +
        page_num +
        `/${id}` +
        "/findAllUsersWithBalance";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      const persons = res.data.result.endUsers;
      var totalPages = Math.ceil(res.data.result.count / 20);
      this.setState({ subtotalpage: totalPages });
      this.setState({ subpersons: persons });
    });

  }


  openInvoice =(id) =>
  {
    console.log(id)
  var customerID =id
  this.setState({customerID:id})
  this.setState({modalOpenInvoice:true})
  var token = reactLocalStorage.get("accessToken");
 
   reactLocalStorage.get("user_id_login");
  
   var date=new Date()
   var page_num = 1
   var ip = API_BASE_URL;
   var s2 = "localhost:3000";

   var apiBaseUrl;
   if (ip.includes(s2)) {
     apiBaseUrl =
       API_BASE_URL + `/core/user/rest/general/getInvoices?customerID=${customerID}&page=${page_num}&fromDate=${this.format(date)}&toDate=${this.format(date)}` 
       
   } else {
     apiBaseUrl =
       API_BASE_URL +
       `/core/user/rest/general/getInvoices?customerID=${customerID}&page=${page_num}&fromDate=${this.format(date)}&toDate=${this.format(date)}`;
   }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data.status === "failed") {
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: i18n.t("Something_wrong.label"),
          animation: "bounce",
          time: 5000,
        });
      }
      if (res.data.result.invoices !== undefined) {
        if (res.data.result.invoices.length >= 0) {
          const persons = res.data.result.invoices;
          this.setState({
            Invoices: persons,
            //  invoiceTotalpage:res.data.result.totalPages
          });
          document.querySelector(".filterpagination").style = "display:none";
          document.querySelector(".invoicepagination").style = "display:block";
        } else {
          var array = [];
          this.setState({
            Invoices: array,
            invoiceTotalpage: 1,
          });
        }
      }
    });
  };

  getInvoicesRefresh = () => {
    var token = reactLocalStorage.get("accessToken");
    //var token = "eyJhbGciOiJIUzUxMiJ9.eyJpc3MiOiJjb3Jwc21zIiwic3ViIjoib3BlcmF0b3IzIiwiaWF0IjoxNjA0NTAwODkwfQ.F7ICqFAC1N5-QzXK7ElJOq7M7ng5OrEHfKnCDRhNuyM8J2OzhEp2qNFqWTLwoP5toi4sL6D4bXEWyn3F8l8Gag"
    reactLocalStorage.get("user_id_login");
    var date = new Date();
    var page_num = 1;
    var customerID= this.state.customerID
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";

    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl = API_BASE_URL + `/core/user/rest/general/getInvoices?customerID=${
        this.state.customerID
      }&page=${page_num}&fromDate=${this.format(date)}&toDate=${this.format(
        date
      )}`;
    } else {
      apiBaseUrl =
        API_BASE_URL +
        `/core/user/rest/general/getInvoices?customerID=${this.state.customerID}&page=${page_num}&fromDate=${this.format(date)}&toDate=${this.format(date)}`;
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data.status === "failed") {
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: i18n.t("Something_wrong.label"),
          animation: "bounce",
          time: 5000,
        });
      }

      if (res.data.result.invoices !== undefined) {
        var totalPages = Math.ceil(res.data.result.invoices / 20);

        if (res.data.result.invoices.length >= 0) {
          this.setState({
            Invoices: res.data.result.invoices,
            invoiceTotalpage: totalPages,
          });
          document.querySelector(".filterpagination").style = "display:none";
          document.querySelector(".invoicepagination").style = "display:block";
        } else {
          var array = [];
          this.setState({
            Invoices: array,
            invoiceTotalpage: 1,
          });
          document.querySelector(".filterpagination").style = "display:none";
          document.querySelector(".invoicepagination").style = "display:block";
        }
      }
    });
  };

  handlePaginationChangeInvoice = (e, { activePage }) => {
    this.setState({ activePage });
    var token = reactLocalStorage.get("accessToken");
    // var token ="eyJhbGciOiJIUzUxMiJ9.eyJpc3MiOiJjb3Jwc21zIiwic3ViIjoib3BlcmF0b3IzIiwiaWF0IjoxNjA0NTAwODkwfQ.F7ICqFAC1N5-QzXK7ElJOq7M7ng5OrEHfKnCDRhNuyM8J2OzhEp2qNFqWTLwoP5toi4sL6D4bXEWyn3F8l8Gag"
    reactLocalStorage.get("user_id_login");
    var page_num = activePage;
   
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl = API_BASE_URL + `/core/user/rest/general/getInvoices?customerID=${
        this.state.customerID
      }&page=${page_num}&fromDate=${this.format(
        this.state.fromDate
      )}&toDate=${this.format(this.state.toDate)}`;
    } else {
      apiBaseUrl =
        API_BASE_URL +
        `/core/user/rest/general/getInvoices?customerID=${this.state.customerID}&page=${page_num}&fromDate=${this.format(this.state.fromDate)}&toDate=${this.format(this.state.toDate)}`;
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data.status === "failed") {
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: i18n.t("Something_wrong.label"),
          animation: "bounce",
          time: 5000,
        });
      }
      if (res.data.result.invoices !== undefined) {
        if (res.data.result.invoices.length >= 0) {
          var totalPages = Math.ceil(res.data.result.invoices / 20);

          this.setState({
            Invoices: res.data.result.invoices,
            invoiceTotalpage: totalPages,
          });
          document.querySelector(".filterpagination").style = "display:none";
          document.querySelector(".invoicepagination").style = "display:block";
        }
      } else {
        var array = [];
        this.setState({
          Invoices: array,
          invoiceTotalpage: 1,
        });
      }
    });
  };

  format(date) {
    const mydate = date;
    const datevalue = mydate.toLocaleDateString();

    var array = datevalue.split("/");
    var day = array[1];
    if (day < 10) {
      day = "0" + day;
    }
    var year = array[2];
    var month = array[0];
    if (month < 10) {
      month = "0" + month;
    }
    return year + "-" + month + "-" + day;
  }

  filterData() {
    this.setState({ modalOpenFilterDetails: false });

    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var page_num = 1;
    if (ip.includes(s2)) {
      apiBaseUrl = API_BASE_URL + `/core/user/rest/general/getInvoices?customerID=${
        this.state.customerID
      }&page=${page_num}&fromDate=${this.format(
        this.state.fromDate
      )}&toDate=${this.format(this.state.toDate)} `;
    } else {
      apiBaseUrl =
        API_BASE_URL +
        `/core/user/rest/general/getInvoices?customerID=${this.state.customerID}&page=${page_num}&fromDate=${this.format(this.state.fromDate)}&toDate=${this.format(this.state.toDate)} `;
    }

    var headers = { "Content-Type": "application/json", token: token };

    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data.result.invoices != undefined) {
        if (res.data.result.invoices.length >= 0) {
          var totalPages = Math.ceil(res.data.result.invoices / 20);
          this.setState({
            Invoices: res.data.result.invoices,
          });
          this.setState({ filterTotalpage: totalPages });
        }
        document.querySelector(".invoicepagination").style = "display:none";
        document.querySelector(".filterpagination").style = "display:block";
      } else {
        var array = [];
        this.setState({
          Invoices: array,
        });
        this.setState({ filterTotalpage: 1 });
      }
    });
  }

  handlePaginationFilterChange = (e, { activePage }) => {
    this.setState({ activePage });
    //window.scrollTo(500, 0);
    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var page_num = activePage;
    if (ip.includes(s2)) {
      apiBaseUrl = API_BASE_URL + `/core/user/rest/general/getInvoices?customerID=${
        this.state.customerID
      }&page=${page_num}&fromDate=${this.format(
        this.state.fromDate
      )}&toDate=${this.format(this.state.toDate)} `;
    } else {
      apiBaseUrl =
        API_BASE_URL +
        `/core/user/rest/general/getInvoices?customerID=${this.state.customerID}&page=${page_num}&fromDate=${this.format(this.state.fromDate)}&toDate=${this.format(this.state.toDate)} `;
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data.result.invoices != undefined) {
        if (res.data.result.invoices.length >= 0) {
          this.setState({
            Invoices: res.data.result.invoices,
          });

          var totalPages = Math.ceil(res.data.result.invoices / 20);
          this.setState({ filterTotalpage: totalPages });
        } else {
          var array = [];
          this.setState({
            Invoices: array,
          });
          this.setState({ filterTotalpage: 1 });
        }
      }
    });
  };

  onChangeFromDate = (event) => {
    const date = new Date(event.target.value);
    this.setState({ fromDate: date });
  };

  onChangeToDate = (event) => {
    const date = new Date(event.target.value);
    this.setState({ toDate: date });
  };

  render() {
    const { activeIndex } = this.state;
    const { selectedOption } = this.state;
    const { activePage, searchactivepage } = this.state;

    return (
      <div className="big_div">
        <Menutest />
        <div className="actionMenu">
          <div className="main_div_sms">
            <div className="sms_main">
              <Grid columns={2} divided className="fixed_form">
                <Grid.Row stretched className="fixed_header">
                  <Grid.Column className="grid_logo">
                    <Segment>
                      <h3 className="text_style green_color">
                        {this.state.isArabic ? (
                          <img
                            src={require("../pictures/ArabicHedar.png")}
                            style={{
                              width: "100% !important",
                              height: "117px",
                              marginTop: "8px",
                              marginRight: "-13px",
                            }}
                            className="himage"
                          />
                        ) : (
                          <img
                            src={require("../pictures/EnglishHedar.png")}
                            style={{
                              width: "100% !important",
                              height: "117px",
                              marginLeft: "-13px",
                              marginTop: "8px",
                            }}
                            className="himage"
                          />
                        )}
                      </h3>
                    </Segment>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          </div>

          <br />
          <br />
          <br />
          <br />
          <div
            className="container_cards"
            style={{ paddingRight: this.state.isArabic ? "" : "20px" }}
          >
            <div
              className={
                this.state.isArabic ? "content_reportarabic" : "content_report"
              }
            >
              <br />
              <Segment
                color="black"
                style={{ padding: "20px", minHeight: "200px" }}
              >
                <br />
                <Divider horizontal>
                  <Header as="h2">
                    <Icon name="users" color="black" />
                    {reactLocalStorage.get("role") === "ROLE_OPERATOR"
                      ? this.state.isArabic
                        ? "عرض الإداريين"
                        : "View Admins"
                      : this.state.isArabic
                      ? "عرض الإداريين الفرعيين"
                      : "View SubAdmins"}
                  </Header>
                </Divider>

                <br />

                <div className="buttonsHeader">
                  <Input
                    size="small"
                    icon="search"
                    placeholder={
                      this.state.isArabic
                        ? "البحث عن اسم المستخدم"
                        : "Search By UserName"
                    }
                    onChange={this.searchchange.bind(this)}
                    style={{ float: "right" }}
                  />

                  {reactLocalStorage.get("role") != "ROLE_OPERATOR" ? (
                    <Button
                      floated="right"
                      icon
                      labelPosition="left"
                      basic
                      size="small"
                      onClick={() => {
                        this.goToAddFunction();
                      }}
                    >
                      {this.state.isArabic ? "إدارة فرعية" : "Sub Admin"}
                      <Icon name="pencil alternate" color="black" />
                    </Button>
                  ) : (
                    ""
                  )}
                </div>

                <br />
                <br />
                <br />
                <Table
                  hover
                  responsive
                  border="0"
                  style={{ textAlign: this.state.isArabic ? "right" : "left" }}
                >
                  <thead className="head" colspan="9">
                    <tr>
                      <td> {i18n.t("Name.label")}</td>
                      <td> {i18n.t("User_name.label")} </td>
                      <td>{i18n.t("user_type.label")}</td>
                      <td> {i18n.t("Full_Name.label")}</td>
                      <td> {i18n.t("email.label")}</td>
                      <td> {i18n.t("Mobile_Number.label")}</td>
                      <td>{i18n.t("Sender_ID.label")}</td>
                      <td
                        style={{
                          display:
                            reactLocalStorage.get("role") === "ROLE_OPERATOR"
                              ? "block"
                              : "none",
                        }}
                      >
                        {" "}
                        {this.state.isArabic ? "الفواتير" : "Invoices"}
                      </td>

                      <td> {i18n.t("BalanceDetails.label")}</td>
                      <td
                        style={{
                          display:
                            reactLocalStorage.get("role") === "ROLE_OPERATOR"
                              ? "block"
                              : "none",
                        }}
                      >
                        {" "}
                        {i18n.t("subadmin.label")}
                      </td>

                      <td width={7}> {i18n.t("createdTime.label")}</td>

                      {/*  <td> {i18n.t("Expiry_Date.label")}</td> */}
                      <td>{this.state.isArabic ? "إعدادات" : "Settings"}</td>
                    </tr>
                  </thead>
                  {this.state.persons.map((person) => (
                    <tbody>
                      <tr>
                        <td collapsing> {person.firstName} </td>
                        <td collapsing>{person.userName}</td>
                        <td collapsing>{person.userType}</td>
                        <td collapsing>
                          {" "}
                          {person.firstName} {person.lastName}
                        </td>
                        <td collapsing>{person.email}</td>
                        <td collapsing textAlign="center">
                          {person.mobile_number}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          <Icon
                            name="eye"
                            id={person._id}
                            color="black"
                            onClick={() => {
                              this.openSenderIds(person._id);
                            }}
                          />
                        </td>
                        <td
                          style={{
                            textAlign: "center",
                            display:
                              reactLocalStorage.get("role") === "ROLE_OPERATOR"
                                ? "block"
                                : "none",
                          }}
                        >
                          <Icon
                            name="eye"
                            id={person._id}
                            color="black"
                            onClick={() => {
                              this.openInvoice(person.customerID);
                            }}
                          />
                        </td>
                        <td style={{ textAlign: "center" }}>
                          <Icon
                            name="eye"
                            color="black"
                            onClick={() => {
                              this.viewBalance(person.balances);
                            }}
                          />
                        </td>

                        <td
                          style={{
                            display:
                              reactLocalStorage.get("role") === "ROLE_OPERATOR"
                                ? "block"
                                : "none",
                          }}
                        >
                          <Icon
                            name="eye"
                            id={person._id}
                            color="black"
                            onClick={(event) => {
                              this.viewSubadmins(event);
                            }}
                          />
                        </td>

                        <td> {person.createdTime}</td>
                        {/*  <td collapsing textAlign="center">
                          {" "}
                          {person.account_expiration}{" "}
                        </td> */}
                        <td collapsing textAlign="center">
                          {" "}
                          <Header as="h5" style={{ textAlign: "right" }}>
                            <Icon
                              name="edit outline"
                              color="black"
                              id={person._id}
                              onClick={(event) => {
                                reactLocalStorage.set(
                                  "id_user_edit",
                                  event.target.id
                                );
                                this.Editform(event);
                              }}
                              className="eye"
                            />

                            <Modal
                              closeIcon={{
                                style: { top: "0rem", right: "0rem" },
                                color: "black",
                                name: "close",
                              }}
                              size="tiny"
                              className="add"
                              trigger={
                                <Icon
                                  className="eye"
                                  name="trash alternate outline"
                                  color="black"
                                  floated={
                                    this.state.isArabic ? "left" : "right"
                                  }
                                  id={person._id}
                                  onClick={(e) => {
                                    this.openModalDeleteAdmin(e);
                                  }}
                                />
                              }
                              style={
                                this.state.isArabic ? modDeletea : modDelete
                              }
                              floated={this.state.isArabic ? "right" : "left"}
                            >
                              <Header
                                icon="trash alternate outline"
                                content={
                                  this.state.isArabic
                                    ? "حذف الإداري"
                                    : "Delete Admin  "
                                }
                              />
                              <Modal.Content>
                                {reactLocalStorage.get("role") !=
                                "ROLE_OPERATOR" ? (
                                  <Header as="h3" textAlign="center">
                                    {" "}
                                    {this.state.isArabic
                                      ? "هل انت متأكد من حذف هذالإداري  ؟"
                                      : "Are you sure you want to delete this  admin ? "}
                                  </Header>
                                ) : (
                                  <Header as="h3" textAlign="center">
                                    {" "}
                                    {this.state.isArabic
                                      ? "هل انت متأكد من حذف هذالإداري الفرعي ؟"
                                      : "Are you sure you want to delete this  subadmin ? "}
                                  </Header>
                                )}
                              </Modal.Content>
                              <Modal.Actions>
                                <Button
                                  basic
                                  color="teal"
                                  content={i18n.t("delete.label")}
                                  onClick={this.Deleteform}
                                />
                                <Button
                                  basic
                                  color="black"
                                  content={i18n.t("Cancel.label")}
                                  onClick={() => {
                                    window.location = "addsubadmin";
                                  }}
                                />
                              </Modal.Actions>
                            </Modal>
                          </Header>
                        </td>
                      </tr>
                    </tbody>
                  ))}
                </Table>

                <br />
                <br />

                <div className="pagination" style={{ display: "block" }}>
                  <Segment basic />
                  <Divider horizontal>
                    <Header
                      as="h5"
                      floated={this.state.isArabic ? "left" : "right"}
                    >
                      <Pagination
                        defaultActivePage={1}
                        onPageChange={this.handlePaginationChange}
                        totalPages={this.state.totalpage}
                        className="page"
                        floated={this.state.isArabic ? "left" : "left"}
                      />
                    </Header>
                    <Header
                      as="h5"
                      floated={this.state.isArabic ? "left" : "right"}
                    />
                  </Divider>
                </div>

                <div className="searchpagination" style={{ display: "none" }}>
                  <Segment basic />
                  <Divider horizontal>
                    <Header
                      as="h5"
                      floated={this.state.isArabic ? "left" : "right"}
                    >
                      <Pagination
                        defaultActivePage={1}
                        onPageChange={this.handlePaginationChangeSearch}
                        totalPages={this.state.totalpagesearch}
                        className="page"
                        floated={this.state.isArabic ? "left" : "left"}
                      />
                    </Header>
                    <Header
                      as="h5"
                      floated={this.state.isArabic ? "left" : "right"}
                    />
                  </Divider>
                </div>
              </Segment>
            </div>
          </div>
        </div>

        <Modal
          closeIcon={{
            style: { top: "0rem", right: "0rem" },
            color: "black",
            name: "close",
          }}
          size="small"
          className="add"
          open={this.state.modalOpenEdit}
          onClose={this.handleCloseEdit}
          style={this.state.isArabic ? modEdita : modEdit}
        >
          {this.state.superOperator ||
          reactLocalStorage.get("role") === "ROLE_OPERATOR" ? (
            <Header icon="edit outline" content={i18n.t("Edit_Admin.label")} />
          ) : (
            <Header
              icon="edit outline"
              content={i18n.t("Edit_Sub_Admin.label")}
            />
          )}

          <Modal.Content scrolling>
            <Form>
              <Form.Group widths="equal">
                <Form.Input
                  fluid
                  label={i18n.t("User_name.label")}
                  name="lname"
                  value={this.state.userName}
                />

                <Form.Input
                  fluid
                  label={i18n.t("First_Name.label")}
                  name="firstName"
                  onChange={(firstName) => {
                    this.setState({ firstName: firstName.target.value });
                  }}
                  defaultValue={this.state.firstName}
                />

                <Form.Input
                  fluid
                  label={i18n.t("Family_Name.label")}
                  name="lastName"
                  onChange={(lastName) => {
                    this.setState({ lastName: lastName.target.value });
                  }}
                  defaultValue={this.state.lastName}
                />
              </Form.Group>

              <Form.Group widths="equal">
                <Form.Input
                  fluid
                  label={i18n.t("Email.label")}
                  name="email"
                  onChange={(email) => {
                    this.setState({ email: email.target.value });
                  }}
                  defaultValue={this.state.email}
                />

                <Form.Input
                  fluid
                  label={i18n.t("Mobile_Number.label")}
                  name="email"
                  onChange={(mobile_number) => {
                    this.setState({
                      mobile_number: mobile_number.target.value,
                    });
                  }}
                  defaultValue={this.state.mobile_number}
                />
              </Form.Group>

              <Form.Group>
                <Form.Input
                  fluid
                  label={i18n.t("landline.label")}
                  name="email"
                  onChange={(land_line) => {
                    this.setState({ land_line: land_line.target.value });
                  }}
                  defaultValue={this.state.land_line}
                  width={5}
                />

                <Form.Input
                  fluid
                  label={i18n.t("weight.label")}
                  name="email"
                  onChange={(weight) => {
                    this.setState({ weight: weight.target.value });
                  }}
                  defaultValue={this.state.weight}
                  width={6}
                />

                <Form.Input
                  fluid
                  label={i18n.t("expiry_date.label")}
                  name="birthday"
                  onChange={(expiry) => {
                    this.setState({ expiry: expiry.target.value });
                  }}
                  defaultValue={this.state.expiry}
                  type="date"
                  width={5}
                />
              </Form.Group>

              <label
                htmlFor="defaultFormCardNameEx"
                className="grey-text font-weight-light"
              >
                {i18n.t("Sender_ID.label")}
              </label>
              <Select
                isMulti
                placeholder="Select ..."
                fluid
                search
                selection
                value={selectedOption}
                onChange={this.handleChangeMenu}
                options={countryOptions}
                className="sender_value"
                id="sender_select"
              />
              <br />

              <Checkbox
                label={i18n.t("active.label")}
                onClick={this.enableEdit}
                id="data_check"
                style={{
                  width: "34%",
                  float: this.state.isArabic ? "right" : "",
                }}
                defaultChecked={this.state.account_status_value}
              />
              <br />
              <Checkbox
                label={i18n.t("otp.label")}
                onClick={this.unBlock}
                id="data_check"
                style={{
                  width: "34%",
                  float: this.state.isArabic ? "right" : "",
                }}
                defaultChecked={this.state.isBlockOtp}
              />

              {reactLocalStorage.get("role") === "ROLE_ADMIN" ? (
                <Checkbox
                label="Approve Request"
                onClick={this.enableApprove}
               id="approve"
                style={{
                  width: "34%",
                  float: this.state.isArabic ? "right" : "",
                }}
                defaultChecked={this.state.smsApproval}
              />
             ):''}
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button
              basic
              color="teal"
              content="Submit"
              onClick={this.handleSubmitEdit}
            />
            <Button
              basic
              color="black"
              content="Cancel"
              onClick={this.handleCloseEdit}
            />
          </Modal.Actions>
        </Modal>

        {/*    /////////////////////////////////////////////////////////////// Add SubAdmin///////////////////////////// */}
        <Modal
          open={this.state.modalOpenAdd1}
          onClose={this.handleCloseAdd1}
          closeIcon={{
            style: { top: "0rem", right: "0rem" },
            color: "black",
            name: "close",
          }}
          style={this.state.isArabic ? modAdda : modAdd}
          className="add"
        >
          {this.state.superOperator ? (
            <Header content={i18n.t("Add_Admin.label")} />
          ) : (
            <Header content={i18n.t("Add_Sub_Admin.label")} />
          )}

          <Modal.Content>
            <Modal.Description scrolling>
              <Form>
                <Form.Group widths="equal">
                  <Form.Input
                    fluid
                    label={i18n.t("First_Name.label")}
                    placeholder={i18n.t("First_Name.label")}
                    onChange={(firstName) => {
                      this.setState({ firstName: firstName.target.value });
                    }}
                  />
                  <Form.Input
                    fluid
                    label={i18n.t("Family_Name.label")}
                    placeholder={i18n.t("Family_Name.label")}
                    onChange={(lastName) => {
                      this.setState({ lastName: lastName.target.value });
                    }}
                  />
                </Form.Group>
                <Form.Group widths="equal">
                  <Form.Input
                    fluid
                    label={i18n.t("User_name.label")}
                    placeholder={i18n.t("User_name.label")}
                    onChange={(userName) => {
                      this.setState({ userName: userName.target.value });
                    }}
                  />
                  <Form.Input
                    fluid
                    defaultValue={i18n.t("Password.label")}
                    type="password"
                    label={i18n.t("Password.label")}
                    placeholder={i18n.t("Password.label")}
                    onChange={(password) => {
                      this.setState({ password: password.target.value });
                    }}
                  />
                </Form.Group>

                <div style={{ display: this.state.showsub ? "none" : "block" }}>
                  <Form.Group widths="equal">
                    <Form.Input
                      type="date"
                      fluid
                      label={i18n.t("expiry_date.label")}
                      placeholder={i18n.t("expiry_date.label")}
                      onChange={(expiry) => {
                        this.setState({ expiry: expiry.target.value });
                      }}
                    />
                    <Form.Input
                      fluid
                      label={i18n.t("weight.label")}
                      placeholder={i18n.t("weight.label")}
                      onChange={(weight) => {
                        this.setState({ weight: weight.target.value });
                      }}
                    />
                  </Form.Group>
                </div>

                <Form.Group widths="equal">
                  <Form.Input
                    label={i18n.t("Email.label")}
                    placeholder={i18n.t("Email.label")}
                    onChange={(email) => {
                      this.setState({ email: email.target.value });
                    }}
                  />
                  <Form.Input
                    label={i18n.t("landline.label")}
                    placeholder={i18n.t("landline.label")}
                    onChange={(land_line) => {
                      this.setState({ land_line: land_line.target.value });
                    }}
                  />
                </Form.Group>

                {i18n.t("Mobile_Number.label")}
                <PhoneInput
                  country={"jo"}
                  value={this.state.mobile_number}
                  onChange={this.handleOnChange}
                  defaultCountry={"jo"}
                  onlyCountries={["jo"]}
                  excludeCountries={["il"]}
                  inputStyle={{
                    paddingLeft: "50px",
                  }}
                />

                <br />
                {i18n.t("Sender_ID.label")}

                <Select
                  isMulti
                  placeholder="Select ..."
                  fluid
                  search
                  selection
                  options={countryOptions}
                  onChange={this.onChangesenderid.bind(this)}
                />
                <br />
                <div style={{ display: this.state.showsub ? "none" : "block" }}>
                  <label
                    htmlFor="defaultFormCardEmailEx"
                    className="grey-text font-weight-light"
                  >
                    {i18n.t("weight.label")}
                  </label>
                  <input
                    type="number"
                    id="defaultFormCardEmailEx"
                    className="form-control"
                    name="email"
                    onChange={this.handleChangeweight}
                  />
                  <br />
                </div>
                <br />

                <Form>
                  <Checkbox
                    label={i18n.t("active.label")}
                    style={{ width: "20%" }}
                    onClick={(event) => {
                      this.enableAdd(event);
                    }}
                    id="active"
                  />

                  {reactLocalStorage.get("role") === "ROLE_ADMIN" ? (
                    <Checkbox
                      label="Approve Request"
                      style={{ width: "20%" }}
                      onClick={this.enableApprove}
                      id="approve"
                    />
                  ) : (
                    ""
                  )}
                </Form>

                <div className="modalIsOpenError" style={{ display: "none" }}>
                  <Segment inverted color="red" tertiary>
                    Password must contain [Captial Letter, Small Letter,
                    Numbers, Special Character, Length More Than 8 Digit,Does
                    Not Contain Username ]
                  </Segment>
                </div>
              </Form>
            </Modal.Description>
          </Modal.Content>
          <Modal.Actions>
            <Button
              basic
              color="black"
              content={i18n.t("Cancel.label")}
              onClick={this.handleCloseAdd1}
            />
            <Button
              basic
              color={this.state.nextState ? "red" : "teal"}
              onClick={this.opentwo}
            >
              {!this.state.nextState && (
                <div>
                  {i18n.t("Next.label")} <Icon name="right chevron" />
                </div>
              )}
              {this.state.nextState && (
                <div>
                  <Icon name="circle notched" loading />
                  Plese wait for few minutes
                </div>
              )}
            </Button>
            {/* <Button basic color="teal" onClick={this.opentwo}
            disabled={this.state.nextState}>
              {i18n.t("Next.label")}
              <Icon name="right chevron" />
            </Button> */}
          </Modal.Actions>
        </Modal>

        <Modal
          closeIcon={{
            style: { top: "0rem", right: "0rem" },
            color: "black",
            name: "close",
          }}
          open={this.state.modalOpenAdd2}
          className="add"
          onClose={this.handleCloseAdd2}
          style={this.state.isArabic ? modAssigna : modAssign}
        >
          <Header content={i18n.t("add_balance.label")} />

          <Modal.Content scrolling>
            <Header as="h3" textAlign="center">
              {" "}
              Are you sure you want to assign balance ?
            </Header>
          </Modal.Content>
          <Modal.Actions>
            <Button
              basic
              color="teal"
              content={i18n.t("Yes.label")}
              onClick={this.confirmRequest}
            />
            <Button
              basic
              color="black"
              content={i18n.t("No.label")}
              onClick={this.handleCloseAdd2}
            />
          </Modal.Actions>
        </Modal>

        <Modal
          closeIcon={{
            style: { top: "0rem", right: "0rem" },
            color: "black",
            name: "close",
          }}
          open={this.state.modalOpenAdd3}
          onClose={this.handleCloseAdd3}
          style={this.state.isArabic ? modAssigna : modAssign}
          className="add"
        >
          <Header content={i18n.t("add_balance.label")} />
          <Modal.Content scrolling>
            <Form.Group widths="equal">
              <p className="h6 black_color">{i18n.t("type.label")}</p>

              <Select
                fluid
                search
                selection
                options={balance_type}
                onChange={this.onChangetype.bind(this)}
              />
              <br />

              <Form.Input
                fluid
                label={i18n.t("balance.label")}
                placeholder={i18n.t("balance.label")}
                onChange={this.handleChangebalance}
              />
              <label
                htmlFor="defaultFormCardNameEx"
                className="grey-text font-weight-light"
                style={{ display: "none" }}
              >
                {i18n.t("billing_code.label")}
              </label>
              <input
                type="text"
                id="defaultFormCardNameEx"
                className="form-control"
                name="billing_code"
                onChange={this.handleChangebillingcode}
                style={{ display: "none" }}
              />
            </Form.Group>
            <br />
            <Checkbox
              label={i18n.t("enable.label")}
              onClick={this.enable2}
              id="1"
              style={{ width: "34%", display: "none" }}
              defaultChecked
            />
          </Modal.Content>
          <Modal.Actions>
            <Button
              basic
              color="teal"
              content={i18n.t("Yes.label")}
              onClick={this.handleSubmitAdd}
            />
            <Button
              basic
              color="black"
              content={i18n.t("No.label")}
              onClick={this.handleCloseAdd3}
            />
          </Modal.Actions>
        </Modal>

        {/* //////////////////////// balance Details ///////////////////////////*/}
        <Modal
          className="add"
          open={this.state.modalOpensubAdmin}
          onClose={this.handleClosesubAdmin}
          style={this.state.isArabic ? modAdda : modAdd}
          size="small"
          closeIcon={{
            style: { top: "0rem", right: "0rem" },
            color: "black",
            name: "close",
          }}
        >
          <Header icon="eye" content="Sub Admins" />
          <Modal.Content scrolling>
            <Table
              hover
              responsive
              border="0"
              style={{ textAlign: this.state.isArabic ? "right" : "left" }}
            >
              <thead className="head" colspan="8">
                <tr>
                  <td> {i18n.t("Name.label")}</td>
                  <td> {i18n.t("User_name.label")} </td>
                  <td> {i18n.t("Full_Name.label")}</td>
                  <td> {i18n.t("email.label")}</td>
                  <td> {i18n.t("Mobile_Number.label")}</td>
                  <td> {i18n.t("BalanceDetails.label")}</td>

                  <td width={7}> {i18n.t("createdTime.label")}</td>
                  <td> {i18n.t("Expiry_Date.label")}</td>
                  <td>{this.state.isArabic ? "إعدادات" : "Settings"}</td>
                </tr>
              </thead>
              {this.state.subpersons.map((person) => (
                <tbody>
                  <tr>
                    <td collapsing> {person.firstName} </td>
                    <td collapsing>{person.userName}</td>
                    <td collapsing>
                      {" "}
                      {person.firstName} {person.lastName}
                    </td>
                    <td collapsing>{person.email}</td>
                    <td collapsing textAlign="center">
                      {person.mobile_number}
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <Icon
                        name="eye"
                        color="black"
                        onClick={() => {
                          this.viewBalance(person.balances);
                        }}
                      />
                    </td>
                    <td> {person.createdTime}</td>
                    <td collapsing textAlign="center">
                      {" "}
                      {person.account_expiration}{" "}
                    </td>
                    <td collapsing textAlign="center">
                      {" "}
                      <Header as="h5" style={{ textAlign: "right" }}>
                        <Icon
                          name="edit outline"
                          color="black"
                          id={person._id}
                          onClick={(event) => {
                            reactLocalStorage.set(
                              "id_user_edit",
                              event.target.id
                            );
                            this.Editform(event);
                          }}
                        />

                        <Modal
                          size="tiny"
                          className="add"
                          trigger={
                            <Icon
                              name="trash alternate outline"
                              color="black"
                              floated={this.state.isArabic ? "left" : "right"}
                              id={person._id}
                              onClick={(e) => {
                                this.openModalDeleteAdmin(e);
                              }}
                            />
                          }
                          style={this.state.isArabic ? modDeletea : modDelete}
                          floated={this.state.isArabic ? "right" : "left"}
                        >
                          <Header
                            icon="trash alternate outline"
                            content={
                              this.state.isArabic
                                ? "حذف الإداري"
                                : "Delete Admin  "
                            }
                          />
                          <Modal.Content>
                            {reactLocalStorage.get("role") !=
                            "ROLE_OPERATOR" ? (
                              <Header as="h3" textAlign="center">
                                {" "}
                                {this.state.isArabic
                                  ? "هل انت متأكد من حذف هذالإداري  ؟"
                                  : "Are you sure you want to delete this  admin ? "}
                              </Header>
                            ) : (
                              <Header as="h3" textAlign="center">
                                {" "}
                                {this.state.isArabic
                                  ? "هل انت متأكد من حذف هذالإداري الفرعي ؟"
                                  : "Are you sure you want to delete this  subadmin ? "}
                              </Header>
                            )}
                          </Modal.Content>
                          <Modal.Actions>
                            <Button
                              basic
                              color="teal"
                              content={i18n.t("delete.label")}
                              onClick={this.Deleteform}
                            />
                            <Button
                              basic
                              color="black"
                              content={i18n.t("Cancel.label")}
                              onClick={() => {
                                window.location = "addsubadmin";
                              }}
                            />
                          </Modal.Actions>
                        </Modal>
                      </Header>
                    </td>
                  </tr>
                </tbody>
              ))}
            </Table>
          </Modal.Content>
          <Modal.Actions>
            <Button
              secondary
              content={i18n.t("Close.label")}
              onClick={this.handleClosesubAdmin}
            />
          </Modal.Actions>
        </Modal>

        <Modal
          className="add"
          open={this.state.modalOpenBalanceDetails}
          onClose={this.handleCloseBalanceDetails}
          style={this.state.isArabic ? modAssigna : modAssign}
          size="small"
          closeIcon={{
            style: { top: "0rem", right: "0rem" },
            color: "black",
            name: "close",
          }}
        >
          <Header
            icon="eye"
            content={this.state.isArabic ? "تفاصيل الرصيد" : "Balance Details"}
          />
          <Modal.Content scrolling>
            <Table
              hover
              responsive
              border="0"
              style={{ textAlign: this.state.isArabic ? "right" : "left" }}
            >
              <tbody>
                <tr>
                  <td>Type of Balance</td>
                  {this.state.Type.map((data) => {
                    return <td>{data}</td>;
                  })}
                  <td />
                </tr>

                <tr>
                  <td>Remaining Balance</td>
                  {this.state.Balance.map((data) => {
                    return <td>{data}</td>;
                  })}
                </tr>
                <tr>
                  <td>Expiry Date</td>
                  {this.state.Expiry.map((data) => {
                    return <td>{data}</td>;
                  })}
                </tr>
              </tbody>
            </Table>
          </Modal.Content>
          <Modal.Actions>
            <Button
              secondary
              content={i18n.t("Close.label")}
              onClick={this.handleCloseBalanceDetails}
            />
          </Modal.Actions>
        </Modal>

        <Modal
          className="add"
          closeIcon={{
            style: { top: "0rem", right: "0rem" },
            color: "black",
            name: "close",
          }}
          open={this.state.modalOpenInvoice}
          onClose={this.handleCloseInvoice}
          style={this.state.isArabic ? modAdda : modAdd}
          size="small"
        >
          <Header
            icon="eye"
            content={this.state.isArabic ? "الفواتير" : "Invoices"}
          />
          <Modal.Content scrolling>
            <div className="buttonsHeader">
              <Button
                floated="right"
                icon
                labelPosition="left"
                basic
                size="small"
                onClick={this.handleOpenFilterDetails}
              >
                <Icon name="sort amount up" /> {i18n.t("filter.label")}
              </Button>
              <Button
                floated="right"
                icon
                labelPosition="left"
                basic
                size="small"
                onClick={() => {
                  this.getInvoicesRefresh();
                }}
              >
                <Icon name="refresh" />{" "}
                {this.state.isArabic ? "تحديث" : "Refresh"}
              </Button>
            </div>
            <br></br> <br></br>
            <Table
              hover
              responsive
              border="0"
              style={{ textAlign: this.state.isArabic ? "right" : "left" }}
            >
              <thead className="head">
                <tr>
                  <td style={{ textAlign: "center" }}>
                    {" "}
                    {this.state.isArabic
                      ? "رقم الفاتورة"
                      : "Invoice Reference Number"}{" "}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {" "}
                    {this.state.isArabic ? "التاريخ" : "Date"}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {" "}
                    {this.state.isArabic ? "الكمية" : "Amount"}{" "}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {" "}
                    {this.state.isArabic
                      ? "رقم المشترك"
                      : "Subscriber MSISDN"}{" "}
                  </td>
                </tr>
              </thead>
              {this.state.Invoices.map((person) => (
                <tbody>
                  <tr>
                    <td style={{ textAlign: "center" }}>
                      {person.invoiceReferenceNumber}
                    </td>
                    <td style={{ textAlign: "center" }}>{person.date}</td>

                    <td style={{ textAlign: "center" }}>{person.amount}</td>

                    <td style={{ textAlign: "center" }}>
                      {person.subscriberMSISDN}
                    </td>
                  </tr>
                </tbody>
              ))}
            </Table>
            <div className="invoicepagination">
              {" "}
              <Segment basic />
              <Divider horizontal>
                <Header
                  as="h5"
                  floated={this.state.isArabic ? "left" : "right"}
                >
                  <Pagination
                    defaultActivePage={1}
                    onPageChange={this.handlePaginationChangeInvoice}
                    totalPages={this.state.invoiceTotalpage}
                    className="page_contact"
                  />
                </Header>
              </Divider>
            </div>
            <div className="filterpagination" style={{ display: "none" }}>
              {" "}
              <Segment basic />
              <Divider horizontal>
                <Header
                  as="h5"
                  floated={this.state.isArabic ? "left" : "right"}
                >
                  <Pagination
                    defaultActivePage={1}
                    onPageChange={this.handlePaginationFilterChange}
                    totalPages={this.state.filterTotalpage}
                    className="page_contact"
                  />
                </Header>
              </Divider>
            </div>
          </Modal.Content>
          <Modal.Actions>
            <Button
              secondary
              content={i18n.t("Close.label")}
              onClick={this.handleCloseInvoice}
            />
          </Modal.Actions>
        </Modal>

        <Modal
          closeIcon={{
            style: { top: "0rem", right: "0rem" },
            color: "black",
            name: "close",
          }}
          size="large"
          open={this.state.modalOpenFilterDetails}
          onClose={this.handleCloseFilterDetails}
          className="add"
          style={this.state.isArabic ? filtera : filter}
        >
          <Header content="Filter" />
          <Modal.Content scrolling>
            <label
              htmlFor="defaultFormCardNameEx"
              className="grey-text font-weight-light"
              style={{ float: this.state.isArabic ? "right" : "left" }}
            >
              {i18n.t("start_date.label")}
            </label>
            <br />
            <input
              type="datetime-local"
              onChange={this.onChangeFromDate}
              className="dateinput"
            />

            <br />

            <label
              htmlFor="defaultFormCardNameEx"
              className="grey-text font-weight-light"
              style={{ float: this.state.isArabic ? "right" : "left" }}
            >
              <br />
              {i18n.t("end_date.label")}
            </label>
            <input
              type="datetime-local"
              onChange={this.onChangeToDate}
              className="dateinput"
            />

            <br />
          </Modal.Content>
          <Modal.Actions>
            <Button
              basic
              color="teal"
              content={i18n.t("Submit.label")}
              onClick={() => {
                this.filterData();
              }}
            />
            <Button
              basic
              color="black"
              content={i18n.t("Cancel.label")}
              onClick={this.handleCloseFilterDetails}
            />
          </Modal.Actions>
        </Modal>

        <Modal
          className="add"
          closeIcon={{
            style: { top: "0rem", right: "0rem" },
            color: "black",
            name: "close",
          }}
          open={this.state.modalOpenSenderIds}
          onClose={this.handleCloseSenderIds}
          style={this.state.isArabic ? modAdda : modAdd}
          size="small"
        >
          <Header
            icon="eye"
            content={this.state.isArabic ? "هويات المرسل" : "Sender IDs"}
          />
          <Modal.Content scrolling>
            <Table
              hover
              responsive
              border="0"
              style={{ textAlign: this.state.isArabic ? "right" : "left" }}
            >
              <thead className="head">
                <tr>
                  <td style={{ textAlign: "center" }}>
                    {this.state.isArabic ? "هوية المرسل" : "Sender ID"}
                  </td>
                </tr>
              </thead>
              {this.state.SenderIds.length > 0 ? (
                this.state.SenderIds.map((sender, index) => (
                  <tbody key={index}>
                    <tr>
                      <td style={{ textAlign: "center" }}>
                        {sender.sender_id || "-"}
                      </td>
                    </tr>
                  </tbody>
                ))
              ) : (
                <tbody>
                  <tr>
                    <td colSpan="1" style={{ textAlign: "center" }}>
                      {this.state.isArabic
                        ? "لا توجد هويات مرسل"
                        : "No Sender IDs found"}
                    </td>
                  </tr>
                </tbody>
              )}
            </Table>
          </Modal.Content>
          <Modal.Actions>
            <Button
              secondary
              content={i18n.t("Close.label")}
              onClick={this.handleCloseSenderIds}
            />
          </Modal.Actions>
        </Modal>

        <SemanticToastContainer />
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return { ...state };
};
export default connect(mapStateToProps)(ViewForm);